/**
 * "
 *         Enable the pdp attribute encrichment experience for retailer.
 *         Retailers in the treatment will see pdp attributes displayed in updated design.
 */
export const ENABLE_PDP_ATTRIBUTES_ENRICHMENT_241010 = 'ENABLE_PDP_ATTRIBUTES_ENRICHMENT_241010';
